module.exports = __webpack_public_path__ + "images/3f4e5c91aecbe1126594b9a0b2ce95d4.svg";